<template>
  <div class="deposit-pages">
    <div class="p16">
        <div>店员日志</div>
    </div>
    <div class="page-head">
      <div class="mains-content br10">
        <div class="member-content-box">
          <div class="member-header">
            <div class="flex-row space-between">
              
            </div>
            <div class="flex-row ml10">
              <v-date @time="changeDate"></v-date>
            </div>
            <!-- <el-input
                placeholder="店员姓名搜索"
                v-model="query.keyword"
                clearable
                class="w200 ml10 mr10"
              ></el-input> -->
            <el-checkbox v-model="isRead" class="ml20">只看未读</el-checkbox>
            <el-checkbox v-model="isMySend" class="ml10">我发出的</el-checkbox>
            <el-button type="primary" @click="searchDoQuery" class="ml30">搜索</el-button>
          </div>
          <div class="m16 white" v-perm="{key:'staffJournal', value: 'staffJournal:list'}">
            <el-table :data="list" :max-height="height - 266" header-cell-class-name="table_header_bgcolor">
              <el-table-column
                :prop="index"
                :align="item.align"
                :label="item.label"
                :width="item.width"
                :min-width="item.minWidth"
                :show-overflow-tooltip="false"
                v-for="(item,index) in columns"
                :key="index"
              >
                <template slot-scope="scope">
                  <div v-if="index == 'readStatus' && scope.row.readStatus == 'unread'" class="backStatusLabel">未读</div>
                  <div v-else-if="index == 'readStatus' && scope.row.readStatus == 'haveRead'" >已读</div>
                  <div v-else >{{Boolean(item.formatDay)?formatDate(scope.row[index]):scope.row[index]}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" width="100" fixed="right">
                <template slot-scope="scope">
                  <el-link type="primary" @click="staffJournalDetailPage(scope.row)">查看详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <detail ref="journalDetail" @change="refreshPage"></detail>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import config from "./config/columns";
import detail from "./detail";
export default {
  mixins: [minxin],
  data() {
    return {
      list: [],
      height: this.$store.getters.MainHeight,
      url: this.$url.staffJournal.list,
      count: this.$url.staffJournal.count,
      columns: config.columns,
      query: {
        readStatus: '',//已读与未读标识
        filterType: '',//我的发出的: send ,我收到的 receive
        beginTime: new Date(),
        endTime: new Date(),
        // keyword:'',
        start: 1,
        size: 20
      },
      totalCount: 0,
      isRead: false,
      isMySend: false,
    };
  },
  components: {detail},
  created() {
    this.totalCounts();
  },
  destroyed() {
    
  },
  mounted() {
    
  },
  methods: {
    searchDoQuery() {
      this.query.start = 1
      this.totalCounts();
    },
    changeDate(value) {
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
    },
    staffJournalDetailPage(row) {
      if (row.id != undefined) {
        this.$refs["journalDetail"].$emit("set", {
            id: row.id
          });
      }
    },
    totalCounts () {
      if (this.isRead) {
        this.query.readStatus = 'unread';
      }else {
        this.query.readStatus = '';
      }
      if (this.isMySend) {
        this.query.filterType = 'send';
      }else {
        this.query.filterType = '';
      }
      this.$api.post(this.$url.staffJournal.count, this.query).then(res => {
        this.getData();
        this.totalCount = res || 0;
      }).catch(error => {});
    },
    refreshPage(org) {
        if (org) {
          this.getData();
        }
      },
  }
};
</script>

<style lang='less' scoped>
@import "../../../assets/css/edit.less";
.page-head {
  // position: relative;
  height: 100%;
}
.deposit-pages {
  position: relative;
  // padding: 16px 16px 0;
}
.mains-content {
  background-color: #fff;
  border-radius: 10px;
  .member-header {
    background: #fff;
    padding: 16px 16px 0;
    display: flex;
    align-items: center;
    border-radius: 10px;
    .top-label {
      width: 90px;
    }
  }
}

.backStatusLabel {
      color: #F5A623;
}

</style>